import { cpf, cnpj } from 'cpf-cnpj-validator';
import { IDENTITY_TYPE, type IdentityType } from '@src/domains/customers/types/auth';

export function isValidBrazilianDocument(identity: string, identityType: IdentityType): boolean {
  return identityType === IDENTITY_TYPE.CNPJ ? cnpj.isValid(identity) : cpf.isValid(identity);
}
